import { Stack } from 'expo-router';
import { useTheme } from 'react-native-paper';
import { useRouter } from 'expo-router';
import { Button } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';
import { I18nextProvider } from 'react-i18next';
import i18n, { initializeI18n } from '@/src/lib/i18n';
import { useEffect, useState } from 'react';
import { View, useWindowDimensions } from 'react-native';
import { useTranslation } from 'react-i18next';
import { clearOwnerDriverStorage } from '@/src/features/owner/ownerDriverPrompt';
import { removeItem } from '@/src/lib/storage';

export default function OnboardingLayout() {
  const { t } = useTranslation('onboarding');
  const theme = useTheme();
  const router = useRouter();
  const [isI18nInitialized, setIsI18nInitialized] = useState(false);
  const { width } = useWindowDimensions();
  
  useEffect(() => {
    const initI18n = async () => {
      await initializeI18n();
      setIsI18nInitialized(true);
    };
    initI18n();
  }, []);
  
  const handleLogout = async () => {
    await Promise.all([
      removeItem('userToken'),
      clearOwnerDriverStorage(),
    ]);
    router.replace('/');
  };

  if (!isI18nInitialized) {
    return null; // or a loading screen
  }
  
  return (
    <I18nextProvider i18n={i18n}>
      <SafeAreaView style={{ flex: 1, backgroundColor: theme.colors.background }}>
        <StatusBar style="dark" />
        <View style={{ 
          flex: 1,
          maxWidth: width > 768 ? 768 : '100%',
          width: '100%',
          alignSelf: 'center',
        }}>
          <Stack
            screenOptions={{
              headerStyle: {
                backgroundColor: theme.colors.primary,
              },
              headerTintColor: theme.colors.onPrimary,
              headerTitleStyle: {
                fontWeight: 'bold',
                fontSize: 20,
              },
              headerShadowVisible: true,
              title: t('onboardingTitle', 'Configuração Inicial'),
              headerLeft: () => null, // Disable back button during onboarding
              headerRight: () => (
                <Button
                  mode="text"
                  textColor={theme.colors.onPrimary}
                  onPress={handleLogout}
                  icon="logout"
                >
                  {t('logout', 'Sair')}
                </Button>
              ),
            }}
          />
        </View>
      </SafeAreaView>
    </I18nextProvider>
  );
} 